module.exports = __webpack_public_path__ + "img/strasburger.a6b0970d.jpg";